import { getId } from 'services/utils'
import { productCommonParse, productCommonWrite } from '../productCommon'
import { APITailoredProduct, TailoredProduct } from '../types'
import { MainProductToApi } from './types/api/request-models'
import { APIMainProduct } from './types/api/response-models'
import { MainProduct } from './types/internal/mainProduct-models'

// ============
// PARSE
// ============

export const mainProductParse = ({
  highlights,
  thenClauseLinkedRules,
  ifClauseLinkedRules,
  customers,
  organizations,
  advanceReservationMin,
  ...res
}: APIMainProduct): MainProduct => ({
  ...res,
  ...productCommonParse(res),
  ...tailoredProductParse({ customers, organizations }),
  sections: res.sections.map(getId),
  highlights,
  ifClauseLinkedRules,
  thenClauseLinkedRules,
})

export const tailoredProductParse = ({
  customers,
  organizations,
}: APITailoredProduct): TailoredProduct => ({
  organizations: organizations.map(getId),
  organizationsFull: organizations,
  customers: customers.map(getId),
  customersFull: customers,
})

// ============
// WRITE
// ============

export const mainProductWrite = async ({
  advanceReservationMin,
  ...rest
}: MainProduct): Promise<MainProductToApi> => ({
  ...rest,
  ...(await productCommonWrite(rest)),
})
